/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { SvgClose } from '@coursera/coursera-ui/svg';

import _t from 'i18n!nls/authentication';

type Props = React.HTMLProps<HTMLButtonElement>;

const styles = {
  close: css`
    align-items: center;
    background: transparent;
    border: none;
    color: #2a73cc;
    cursor: pointer;
    display: inline-flex;
    font-size: inherit;
    height: 50px;
    justify-content: center;
    padding: 0;
    transition: background-color 250ms ease-out, box-shadow 250ms ease-out;
    width: 50px;

    &:focus {
      background-color: #f3f8ff;
      box-shadow: 0 0 0 2px #fff, 0 0 0 3px #6a52e9, 0 0 0 4px #f3f8ff;
      outline: none;
    }

    @media (hover: hover) {
      &:hover {
        background-color: #f3f8ff;
      }
    }

    @media (min-width: 600px) {
      border-radius: 50%;
    }
  `,
};

const CloseButton = ({ className, ...props }: Props) => (
  <button data-e2e="close-modal-button" className={className} css={styles.close} {...props} type="button">
    <SvgClose aria-label={_t('Close modal')} />
  </button>
);

export default CloseButton;
